import React from 'react';
import Select from 'react-select';
import { filterSelect } from '../../utils/utils';
import 'whatwg-fetch';

export default class AppProposalInput extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpen: true,
      extended: true,
      productSelected: '',
      refIsEditable: false,
      isExtendWording: false,
      commercialWording: '',
      refId: -1,
      baseFAS: 0,
      newFAS: 0,
      baseRM: 0,
      newRM: 0,
      baseRA: 0,
      newRA: 0,
      productQuantity: 0,
    };
    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleInputSelectChange = this.handleInputSelectChange.bind(this);
    this.destroy = this.destroy.bind(this);
    this.extend = this.extend.bind(this);
    this.minify = this.minify.bind(this);
    this.toggleExtendWording = this.toggleExtendWording.bind(this);
  }

  handleInputChange(event) {
    const target = event.target;
    const value = target.value;
    const name = target.name;

    if (name === 'productQuantity' && value > 100000 && this.props.id.split('-')[0] === 'virtual') {
      this.props.openToast(false, 'Veuillez créer une référence de type "pack" pour des quantitées supérieures');
    } else {
      this.setState({
        [name]: value,
      });

      let quantity = this.state.productQuantity;

      if (name === 'newFAS') {
        // Update without changing the ref
        this.props.updateTotal(
          this.props.id,
          this.state.refId,
          value,
          this.state.baseFAS,
          this.state.newRM,
          this.state.baseRM,
          this.state.newRA,
          this.state.baseRA,
          quantity
        );
      }
      if (name === 'newRM') {
        // Update without changing the ref
        this.props.updateTotal(
          this.props.id,
          this.state.refId,
          this.state.newFAS,
          this.state.baseFAS,
          value,
          this.state.baseRM,
          this.state.newRA,
          this.state.baseRA,
          quantity
        );
      }
      if (name === 'newRA') {
        // Update without changing the ref
        this.props.updateTotal(
          this.props.id,
          this.state.refId,
          this.state.newFAS,
          this.state.baseFAS,
          this.state.newRM,
          this.state.baseRM,
          value,
          this.state.baseRA,
          quantity
        );
      }
      if (name === 'productQuantity') {
        // Update without changing the ref
        this.props.updateTotal(
          this.props.id,
          this.state.refId,
          this.state.newFAS,
          this.state.baseFAS,
          this.state.newRM,
          this.state.baseRM,
          this.state.newRA,
          this.state.baseRA,
          value
        );
      }

      if (name === 'baseFAS') {
        // Update without changing the ref
        this.props.updateTotal(
          this.props.id,
          this.state.refId,
          this.state.newFAS,
          value,
          this.state.newRM,
          this.state.baseRM,
          this.state.newRA,
          this.state.baseRA,
          quantity
        );
      }
      if (name === 'baseRM') {
        // Update without changing the ref
        this.props.updateTotal(
          this.props.id,
          this.state.refId,
          this.state.newFAS,
          this.state.baseFAS,
          this.state.newRM,
          value,
          this.state.newRA,
          this.state.baseRA,
          quantity
        );
      }
      if (name === 'baseRA') {
        // Update without changing the ref
        this.props.updateTotal(
          this.props.id,
          this.state.refId,
          this.state.newFAS,
          this.state.baseFAS,
          this.state.newRM,
          this.state.baseRM,
          this.state.newRA,
          value,
          quantity
        );
      }

      if (name === 'commercialWording') {
        this.props.updateWording(this.props.id, value);
      }
    }
  }

  handleInputSelectChange(val) {
    // Reference Select Input is chosed
    if (val) {
      // in case of an input reset, the val will be null
      const value = val['id'];
      let currFAS = val['accessCharges'];
      let currRM = val['mensualRecurrency'];
      let currRA = val['annualRecurrency'];
      let currEditable = val['editable'];
      let currCommercialWording = val['commercialWording'] ? val['commercialWording'] : val['wording'];

      this.setState({
        productSelected: value,
        refIsEditable: currEditable,
        refId: value,
        baseFAS: currFAS,
        newFAS: this.props.applyMarginFAS(currFAS),
        baseRM: currRM,
        newRM: this.props.applyMarginRM(currRM),
        baseRA: currRA,
        newRA: this.props.applyMarginRA(currRA),
        productQuantity: 1,
        commercialWording: currCommercialWording,
      });
      this.props.updateBaseTotal(this.props.id, value, currFAS, currRM, currRA);
      if (currCommercialWording !== '') {
        this.props.updateWording(this.props.id, currCommercialWording);
      }
      //console.log("Selected: " + JSON.stringify(val));
    } else {
      // We have to reset -> no ref chosed
      this.setState({
        productSelected: undefined,
        refIsEditable: false,
        refId: -1,
        baseFAS: 0,
        newFAS: 0,
        baseRM: 0,
        newRM: 0,
        baseRA: 0,
        newRA: 0,
        productQuantity: 0,
        commercialWording: '',
      });
      this.props.updateBaseTotal(this.props.id, -1, 0, 0, 0);
      this.props.updateWording(this.props.id, '');
    }
  }

  destroy() {
    this.props.updateBaseTotal(this.props.id, -1, 0, 0, 0);
    this.props.onDestroy();
  }

  extend() {
    this.setState({
      extended: true,
    });
  }

  minify() {
    this.setState({
      extended: true,
    });
  }

  componentDidMount() {
    if (this.props.save) {
      // this object has already been saved
      this.setState({
        productSelected: {
          id: this.props.save.productReference.id,
          wording: this.props.save.productReference.wording,
        },
        refIsEditable: this.props.save.productReference.editable,
        refId: this.props.save.productReference.id,
        commercialWording: this.props.save.commercialWording ? this.props.save.commercialWording : '',
        baseFAS: this.props.save.basicAccessCharges,
        newFAS: this.props.save.accessCharges,
        baseRM: this.props.save.basicMensualRecurrency,
        newRM: this.props.save.mensualRecurrency,
        baseRA: this.props.save.basicAnnualRecurrency,
        newRA: this.props.save.annualRecurrency,
        productQuantity: this.props.save.quantity,
      });
      this.props.updateBaseTotal(
        this.props.id,
        this.props.save.productReference.id,
        this.props.save.accessCharges,
        this.props.save.mensualRecurrency,
        this.props.save.annualRecurrency,
        this.props.save.quantity,
        this.props.save.basicAccessCharges,
        this.props.save.basicMensualRecurrency,
        this.props.save.basicAnnualRecurrency,
        this.props.save.id
      );
      if (this.props.save.commercialWording) {
        this.props.updateWording(this.props.id, this.props.save.commercialWording);
      }
    }
  }

  componentDidUpdate(prevProps, prevState) {
    // Margin update
    if (prevProps.marginFAS != this.props.marginFAS) {
      this.setState({
        newFAS: this.props.applyMarginFAS(this.state.baseFAS),
      });
    }
    if (prevProps.marginRM != this.props.marginRM) {
      this.setState({
        newRM: this.props.applyMarginRM(this.state.baseRM),
      });
    }
    if (prevProps.marginRA != this.props.marginRA) {
      this.setState({
        newRA: this.props.applyMarginRA(this.state.baseRA),
      });
    }
    // FAS or RM or RA update
    if (
      (prevState.newFAS != this.state.newFAS && this.state.refId != -1) ||
      (prevState.newRM != this.state.newRM && this.state.refId != -1) ||
      (prevState.newRA != this.state.newRA && this.state.refId != -1)
    ) {
      this.props.updateTotal(
        this.props.id,
        this.state.refId,
        this.state.newFAS,
        this.state.baseFAS,
        this.state.newRM,
        this.state.baseRM,
        this.state.newRA,
        this.state.baseRA,
        this.state.productQuantity
      );
    }
    return true;
  }

  toggleExtendWording() {
    this.setState({
      isExtendWording: !this.state.isExtendWording,
    });
  }

  render() {
    if (this.state.isOpen === false) return null;

    const dataRef = this.props.data;

    return (
      <div>
        <div
          className='appBillingInput toggleColor alignHorizontal'
          onMouseEnter={this.extend}
          onMouseLeave={this.minify}
        >
          <div className='alignHorizontal'>
            <label className='label-billing'>Réf:</label>
            <span
              onClick={this.toggleExtendWording}
              className={
                'btn-row-action icon ' +
                (this.state.isExtendWording ? 'icon-chevron-thin-up ' : 'icon-chevron-thin-down ')
              }
            />
            <Select
              className='inputRefSelect'
              name='productSelected'
              value={this.state.productSelected}
              labelKey={'wording'}
              valueKey={'id'}
              options={dataRef}
              onChange={this.handleInputSelectChange}
              noResultsText={'Aucun résultat'}
              placeholder={'Référence'}
              clearValueText={'Supprimer'}
              ignoreCase={false}
              filterOption={filterSelect}
            />
          </div>
          <div
            onMouseEnter={this.props.triggerFAS}
            onMouseLeave={this.props.resetFASRM}
            className={'alignHorizontal ' + (this.props.activeFAS ? 'activeFAS ' : '')}
          >
            <label className='label-billing'>FAS:</label>
            <input
              min={0}
              max={this.state.newFAS}
              name='baseFAS'
              value={this.state.baseFAS}
              onChange={this.handleInputChange}
              type='number'
              className='form-control inputQuantity'
              placeholder='...'
              {...(!this.state.refIsEditable && { readOnly: true })}
            />
            <span className='icon icon-arrow-right' />
            <input
              name='newFAS'
              value={this.state.newFAS}
              onChange={this.handleInputChange}
              type='number'
              className='form-control inputPrice'
              placeholder='...'
            />
          </div>
          <div
            onMouseEnter={this.props.triggerRM}
            onMouseLeave={this.props.resetFASRM}
            className={'alignHorizontal ' + (this.props.activeRM ? 'activeRM ' : '')}
          >
            <label className='label-billing'>RM:</label>
            <input
              min={0}
              max={this.state.newRM}
              name='baseRM'
              value={this.state.baseRM}
              onChange={this.handleInputChange}
              type='number'
              className='form-control inputQuantity'
              id='inputCost'
              placeholder='...'
              {...(!this.state.refIsEditable && { readOnly: true })}
            />
            <span className='icon icon-arrow-right' />
            <input
              min={this.state.baseRM}
              name='newRM'
              value={this.state.newRM}
              onChange={this.handleInputChange}
              type='number'
              className='form-control inputQuantity'
              placeholder='...'
            />
          </div>
          <div
            onMouseEnter={this.props.triggerRA}
            onMouseLeave={this.props.resetFASRM}
            className={'alignHorizontal ' + (this.props.activeRA ? 'activeRA ' : '')}
          >
            <label className='label-billing'>RA:</label>
            <input
              min={0}
              max={this.state.newRA}
              name='baseRA'
              value={this.state.baseRA}
              onChange={this.handleInputChange}
              type='number'
              className='form-control inputQuantity'
              id='inputCost'
              placeholder='...'
              {...(!this.state.refIsEditable && { readOnly: true })}
            />
            <span className='icon icon-arrow-right' />
            <input
              min={this.state.baseRA}
              name='newRA'
              value={this.state.newRA}
              onChange={this.handleInputChange}
              type='number'
              className='form-control inputQuantity'
              placeholder='...'
            />
          </div>
          <div className='alignHorizontal'>
            <label className='label-billing'>Qt:</label>
            <input
              min='1'
              name='productQuantity'
              value={this.state.productQuantity}
              onChange={this.handleInputChange}
              type='number'
              className='form-control inputQuantity'
              placeholder='...'
            />
          </div>
          <button onClick={this.destroy} type='button' className='btn btn-sm btn-outline-success'>
            <span className='icon icon-cross' />
          </button>
        </div>

        {this.state.isExtendWording && (
          <div className='alignHorizontal appBillingInput-extended-row'>
            <span className='icon icon-open-book' />
            <textarea
              name='commercialWording'
              value={this.state.commercialWording}
              onChange={this.handleInputChange}
              maxLength={500}
              className='form-control'
              placeholder='Nom commercial'
            />
          </div>
        )}
      </div>
    );
  }
}
